import { NewsLetter } from "../../components/newsLetter";

import { ChiSiamoDesc } from "./chiSiamoDesc";
import { Videos } from "../whatIsRent/videos";
import { RoundedInfo } from "../../components/roundedInfo";
import { Team } from "./team";

export function ChiSiamo() {
  return (
    <>
      <ChiSiamoDesc />

      {/* Il team precede i blocchi dedicati alla mission aziendale. */}
      <Team />

      <RoundedInfo inverted reverse id="rDWZpbCcVCiV6vR8swUfk"></RoundedInfo>
      <RoundedInfo inverted id="6YB8KqyNHAAv6w3yYIU9Ap"></RoundedInfo>

      <RoundedInfo reverse inverted id="4iPQnF7nGZrNXGMBkZMUno"></RoundedInfo>

      <RoundedInfo id="6UWfZxMMgpLX9mbeCdohIZ"></RoundedInfo>
      <Videos />

      <NewsLetter />
    </>
  );
}
